import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { ActionsBar } from './styles';
import RadioButtonQuestion from '../../../../../RadioButtonQuestion';

const purchaseOptions = [
  {
    value: 'product-and-install',
    label: 'Product and Installation',
    toolTip: 'Select this option to purchase<br/>both products and installation<br/>in one transaction.',
  },
  {
    value: 'product-only',
    label: 'Product Only',
    toolTip: 'Select this option to purchase<br/>the product only, without<br/>installation for this window.',
  },
  {
    value: 'do-not-include',
    label: 'Save for Later',
    toolTip: 'Select this option if you are not<br/>ready to purchase this product.<br/>It will be saved for later.',
  },
];

const InstallationItemActionsBar = ({
  purchaseOption,
  hasProduct,
  setPurchaseOption,
}) => {
  useEffect(() => {
    if (!purchaseOption && hasProduct) {
      setPurchaseOption('product-and-install');
    }
  }, [purchaseOption, hasProduct]);

  return (
    <ActionsBar>
      <RadioButtonQuestion
        name="purchaseOption"
        options={purchaseOptions}
        value={purchaseOption}
        onChange={setPurchaseOption}
        thin
      />
    </ActionsBar>
  );
};
InstallationItemActionsBar.propTypes = {
  purchaseOption: PropTypes.string,
  hasProduct: PropTypes.bool.isRequired,
  setPurchaseOption: PropTypes.func.isRequired,
};

InstallationItemActionsBar.defaultProps = {
  purchaseOption: '',
};

export default InstallationItemActionsBar;
